import { useDispatch, useSelector } from "react-redux";
import { radioDataSelector } from "../../redux/modules/radio/radio-selectors";
import { loadRadioData } from "../../redux/modules/radio/radio-actions";
import { RADIO_ENTITY } from "../../constants/radioEntities";
import React, {useCallback} from "react";
import { isRadioPageLoaded } from "../../redux/modules/radio/radio-helpers";
import { useRadioMetadata } from "./useRadioMetadata";

export const useRadioMediaplan = (id) => {
    const dispatch = useDispatch();
    useRadioMetadata();

    const entityData = useSelector(radioDataSelector);

    const loadMediaplanData = useCallback((id) => (
        dispatch(loadRadioData(RADIO_ENTITY.MEDIAPLAN, id)))
    ,[dispatch]);

    React.useEffect(() => {
        loadMediaplanData(id)
    }, [id, loadMediaplanData]);

    const isLoaded = isRadioPageLoaded(RADIO_ENTITY.MEDIAPLAN, entityData);

    return [entityData, isLoaded];
}
